import { useClient } from '@composables/use-clients';
import { UserType } from '@api/types';
import { urls } from '@api/urls';
import {
  PostRequestArgsType,
  PutRequestArgsType,
} from '@api/v1/types';
import { withTryCatch } from '@api/v1/error-handlers';

export type PutCurrentUserPayloadType = (
  Pick<UserType, 'firstName' | 'lastName' | 'headline' | 'location' | 'timezoneCode'>
);

export type DeleteCurrentUserPayloadType = {
  password: string;
};

export const apiFetchCurrentUser = async ({
  errorConfig = {},
  callbacks = {},
} = {}) => {
  const impl = async () => {
    const { client } = useClient('auth');
    const res = await client.get({ url: urls.v1.currentUser() });
    return res;
  };

  return withTryCatch({ impl, errorConfig, callbacks });
};

export const apiUpdateCurrentUser = async ({
  payload,
  errorConfig = {},
  callbacks = {},
}: PutRequestArgsType<PutCurrentUserPayloadType>) => {
  const impl = async () => {
    const { client } = useClient('auth');
    const res = await client.put({
      url: urls.v1.currentUser(),
      payload,
    });
    return res;
  };

  return withTryCatch({ impl, errorConfig, callbacks });
};

export const apiDeleteCurrentUser = async ({
  payload,
  errorConfig = {},
  callbacks = {},
}: PostRequestArgsType<DeleteCurrentUserPayloadType>) => {
  const impl = async () => {
    const { client } = useClient('auth');
    const res = await client.post({
      url: urls.v1.currentUserDelete(),
      payload,
    });
    return res;
  };

  return withTryCatch({ impl, errorConfig, callbacks });
};
